(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ThemeProvider", [], factory);
	else if(typeof exports === 'object')
		exports["ThemeProvider"] = factory();
	else
		root["ThemeProvider"] = factory();
})(this, function() {
return 